export const photoModerationEn = {
  detail: {
    actions: {
      accept: 'Accept',
      acceptTooltip: 'Approve and publish this photo to the menu.',
      reject: 'Reject',
      rejectTooltip: 'Reject this photo and pick a reason.',
      unsure: 'Unsure',
      unsureTooltip: 'Escalate for a senior reviewer to decide.',
    },
    alreadyHandled: 'This submission has already been reviewed.',
    back: 'Back to queue',
    decisionError: 'Couldn’t save your decision. Please try again.',
    itemAlreadyAcceptedError:
      'Another photo for this item was already accepted. Reject or unstage it first.',
    loadError: 'Couldn’t load this submission. Please try again.',
    metadata: {
      brand: 'Brand',
      description: 'Description',
      guest: 'Guest',
      location: 'Location',
      modifiers: 'Options',
      none: 'None',
      submitted: 'Submitted',
    },
    photoAlt: 'Guest-submitted photo of {item}',
  },
  page: {
    description: 'Review and moderate guest-sourced menu photos.',
    title: 'Photo Moderation',
  },
  queue: {
    brandPending: '{count} pending',
    cardAria: 'Review guest photo for {item}',
    columns: {
      action: 'Action',
      item: 'Item',
      photo: 'Photo',
      uploaded: 'Uploaded',
    },
    empty: {
      description: 'No photos waiting for review right now.',
      title: 'All caught up.',
    },
    error: {
      retry: 'Try again',
      title: 'Couldn’t load the review queue.',
    },
    groupBy: {
      brand: 'By brand',
      item: 'By item',
      label: 'Group submissions by',
    },
    photoAlt: 'Guest-submitted photo of {item}',
    sla: {
      ariaAtRisk: 'Uploaded {hours} hours ago — at risk',
      ariaOk: 'Uploaded {hours} hours ago',
      ariaOverdue: 'Uploaded {hours} hours ago — overdue',
      daysAgo: '{days}d ago',
      hoursAgo: '{hours}h ago',
    },
  },
  ready: {
    columns: {
      action: 'Action',
      item: 'Item',
      photo: 'Photo',
      uploaded: 'Uploaded',
    },
    confirm: {
      confirm: 'Promote',
      confirmAll: 'Promote all ({count})',
      message:
        'This publishes the photo as the menu item’s primary image, replacing the current one. Guests see it immediately.',
      messageAll:
        'This publishes all {count} ready photos to their menu items, replacing each current primary image. Guests see them immediately.',
      title: 'Promote this photo?',
      titleAll: 'Promote all ready photos?',
    },
    count: '{count} ready to publish',
    empty: {
      description: 'Accepted photos will show up here, staged to publish.',
      title: 'Nothing staged.',
    },
    error: {
      retry: 'Try again',
      title: 'Couldn’t load the ready photos.',
    },
    photoAlt: 'Accepted guest photo of {item}',
    promote: 'Promote',
    promoteAll: 'Promote all ({count})',
    promoteAllTooltip: 'Publish every ready photo to its menu item.',
    promoteError: 'Couldn’t publish. Please try again.',
    promoteTooltip: 'Publish this photo to the menu now.',
    unstage: 'Unstage',
    unstageError: 'Couldn’t unstage. Please try again.',
    unstageTooltip: 'Send this photo back to the review queue.',
  },
  reject: {
    cancel: 'Cancel',
    confirm: 'Reject',
    noteLabel: 'Note',
    notePlaceholder: 'Add context for this rejection…',
    noteRequired: 'A note is required when choosing “Other”.',
    reasons: {
      content_fraud: {
        description: 'Fake, stock, or spam submission.',
        label: 'Fraud or spam',
      },
      content_inappropriate: {
        description: 'Offensive or off-topic content.',
        label: 'Inappropriate',
      },
      content_pii: {
        description: 'Shows faces, license plates, or personal info.',
        label: 'Contains personal info',
      },
      content_wrong_item: {
        description: 'The photo doesn’t match this menu item.',
        label: 'Wrong item',
      },
      other: {
        description: 'Something else — add a note.',
        label: 'Other',
      },
      quality_blurry: {
        description: 'Out of focus or low resolution.',
        label: 'Blurry',
      },
      quality_lighting: {
        description: 'Too dark, washed out, or heavy glare.',
        label: 'Poor lighting',
      },
      quality_partial: {
        description: 'The item is cut off or not fully visible.',
        label: 'Partial or cropped',
      },
    },
    title: 'Reject this photo',
  },
  rejected: {
    columns: {
      item: 'Item',
      photo: 'Photo',
      reason: 'Reason',
      rejectedAt: 'Rejected',
    },
    count: '{count} rejected',
    empty: {
      description: 'Rejected photos will show up here for reference.',
      title: 'Nothing rejected yet.',
    },
    error: {
      retry: 'Try again',
      title: 'Couldn’t load the rejected photos.',
    },
    photoAlt: 'Rejected guest photo of {item}',
    reasonUnknown: 'Unknown',
  },
  tabs: {
    queue: 'Queue',
    queueHint: 'New guest submissions awaiting review.',
    ready: 'Ready',
    readyHint: 'Accepted photos staged to publish. Promote when you’re ready.',
    rejected: 'Rejected',
    rejectedHint: 'Photos turned down by a reviewer.',
    staging: 'Escalated',
    stagingHint: 'Flagged as unsure — needs a senior review.',
  },
}
